import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SecurityUpdateIcon(props: IconProps) {
    return <Icon {...props} iconKey={"security_update"}/>
}
